module.exports = __webpack_public_path__ + "assets/img/c_zqgf.db7a19b9.png";